"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Nursery(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M19.99 2c.5 0 1 .2 1.4.6.8.8.8 2 0 2.8l-.7.7c-.402.4-.4 1-.1 1.3.4.4.4 1 0 1.4l-.782.781c.47 1.552.114 3.3-1.112 4.527l-7.02 7.018-.023.02c-1.257 1.117-3.188 1.143-4.37-.038l-4.4-4.402c-1.184-1.181-1.157-3.112-.04-4.37l.02-.021 7.02-7.022a4.526 4.526 0 0 1 3.206-1.329c.393 0 .782.071 1.164.172l.836-.836c.4-.4 1-.4 1.4 0a.966.966 0 0 0 1.401 0l.7-.7c.4-.4.9-.6 1.4-.6zm-6.9 3.936c-.64 0-1.279.256-1.794.77l-6.959 6.958-.002.004c-.478.542-.455 1.209-.039 1.625l4.4 4.4c.416.416 1.083.44 1.625-.039l.204-.204-2.342-2.342 1.414-1.415 2.342 2.342L12.976 17l-2.393-2.393 1.414-1.413 2.393 2.391 1.025-1.025-2.422-2.341 1.391-1.438 2.445 2.365.453-.453c1.03-1.028 1.03-2.556 0-3.585l-2.4-2.402c-.515-.514-1.154-.77-1.793-.77z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Nursery;
